module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-1-Whats-Your-Function-a622750e2c0a2e047cf10932b2a5d2db.pdf";